export default{tabNavigation:"w_ED",list:"w_EE",tabNavigationItemContainer:"w_EF"};
